import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';
import { refresh } from 'ionicons/icons';
import { getShoppingCart } from '../utils/functions';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));
        getRequest(data, controller).then(
            (response) => {

                if (data.typeOption == "get_list_purchases") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            purchasesDB: response.data,
                            data_pagin_purchasesDB: response.data.data,
                            refresh_list: false,
                            categories_purchases_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            purchasesDB: response.data,
                            refresh_list: false,
                            categories_purchases_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_purchasesDB'));
                    }
                } else if (data.typeOption == "get_search_products") {
                    dispatch(setData({
                        list_search_products: response.data,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: false,
                        open_modal_list_products: true,
                        view_active: data.view_active
                    }));
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active,
            list_search_products: [],
        }));

        postRequest_(data, controller).then(
            (response) => {

                if (data.typeOption == "saveDataPurchase") {

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        list_search_products: [],
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                    }))
                } else if (data.typeOption == "destroyDatapurchase") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        list_search_products: [],
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                    }))
                } else if (data.typeOption == "updateDataPurchase") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        list_search_products: [],
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                    }))
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}